import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { loginOneSignal, logoutOneSignal } from '../lib/onesignal'
import { analytics, EVENTS } from '../lib/analytics'

interface AuthUser {
  id: string
  name: string
  email: string
  tenant_id: string
  roles?: string[]
  permissions?: string[]
}

interface AuthState {
  token: string | null
  refreshToken: string | null
  user: AuthUser | null
  isAuthenticated: boolean

  setAuth: (token: string, refreshToken: string, user: AuthUser) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      user: null,
      isAuthenticated: false,

      setAuth: (token, refreshToken, user) => {
        loginOneSignal(user.id, user.tenant_id, user.roles)
        analytics.identify(user)
        analytics.setTenantGroup(user.tenant_id)
        analytics.track(EVENTS.SESSION_STARTED, { method: 'password', platform: 'web' })
        set({
          token,
          refreshToken,
          user,
          isAuthenticated: true,
        })
      },

      logout: () => {
        logoutOneSignal()
        analytics.track(EVENTS.SESSION_ENDED, { platform: 'web' })
        analytics.reset()
        set({
          token: null,
          refreshToken: null,
          user: null,
          isAuthenticated: false,
        })
      },
    }),
    {
      name: 'omnitrace-auth',
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        if (state?.isAuthenticated && state.user) {
          loginOneSignal(state.user.id, state.user.tenant_id, state.user.roles)
          analytics.identify(state.user)
        }
      },
    },
  ),
)
